import {OutputEmitterRef, Signal, WritableSignal} from "@angular/core";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";

/** Sann dersom det finnes abonnenter på angitt output.
 * Enn så lenge eksponerer ikke angular (per angular 18) ikke noe api for å sjekke dette */
export function erLyttereRegistrertPåOutputsignal(output: OutputEmitterRef<any>) {
    return erIkkeTomListe(output['listeners']);
}

/** Oppdaterer angitt signal til angitt verdi, returnerer signalets opprinnelig verdi. */
export function oppdaterSignal<V>(signal: WritableSignal<V>, nyVerdi: V): V {
    const opprinneligVerdi = signal();
    signal.set(nyVerdi);
    return opprinneligVerdi;
}
